import dayjs from 'dayjs';

import { COMMON_DATE_FORMAT } from '../constants';

export const formatPrice = (price?: number | string): string => {
  if (!price && price !== 0) return '';
  if (typeof price !== 'number') {
    price = Number(price.replace(/[^0-9.]/g, ''));
  }
  return price.toLocaleString('ru-RU');
};

export const formatPhoneNumber = (
  value: string | null | undefined,
  defaultValue: string = ''
): string => {
  if (!value) return defaultValue;
  const digits = value.replace(/\D/g, '');
  const match = digits.match(/^7(\d{3})(\d{3})(\d{2})(\d{2})$/);

  if (!match) return value;

  const [, area, first, second, third] = match;
  return `+7 (${area}) ${first}-${second}-${third}`;
};

export const cleanFullNameValue = (value: string) => {
  const cleanedNameValue = value
    .replace(/[^а-яё\s]/gi, '')
    .replace(/\s{2,}/g, ' ')
    .trimStart();
  const capitalizedValue = cleanedNameValue
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
  return capitalizedValue;
};

export const formatLastName = (value: string): string => {
  const cleanedValue = value.replace(
    /[^a-zA-Zа-яА-ЯёЁӘәҒғҚқҢңӨөҰұҮүҺһІі\- ]/g,
    ''
  );
  return cleanedValue;
};

export const formatDate = (date: string) => {
  if (!date) return '';
  return dayjs(date).format(COMMON_DATE_FORMAT);
};
